var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4058 0.00416134L7.81228 0C4.89852 0 3.01551 1.9319 3.01551 4.92203V7.19141H0.407811C0.182475 7.19141 0 7.37409 0 7.59943V10.8875C0 11.1128 0.182683 11.2953 0.407811 11.2953H3.01551V19.5922C3.01551 19.8175 3.19799 20 3.42332 20H6.82563C7.05097 20 7.23344 19.8173 7.23344 19.5922V11.2953H10.2825C10.5078 11.2953 10.6903 11.1128 10.6903 10.8875L10.6915 7.59943C10.6915 7.49123 10.6484 7.38762 10.5721 7.31105C10.4957 7.23448 10.3917 7.19141 10.2835 7.19141H7.23344V5.26763C7.23344 4.34298 7.45378 3.87358 8.65828 3.87358L10.4054 3.87295C10.6305 3.87295 10.813 3.69027 10.813 3.46514V0.411972C10.813 0.187052 10.6308 0.00457747 10.4058 0.00416134Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/FacebookIcon.ca684d69.svg";
export { ForwardRef as ReactComponent };